import { Component, Input, OnInit } from '@angular/core';
import { IColumn } from '../../interfaces/IColumn'
import { ModalController } from '@ionic/angular';
import { ResponseNotificationService } from '../../services/response-notification/response-notification.service';

@Component({
  selector: 'app-column-select',
  templateUrl: './column-select.component.html',
  styleUrls: ['./column-select.component.scss'],
})

export class ColumnSelectComponent implements OnInit {

  @Input() columns:IColumn[] = [];
  selectAll:boolean = false
  constructor(
    private _modalController:ModalController,
    private _responseNotificationService:ResponseNotificationService
  ) { }

  ngOnInit() { 
    this.updateSelectAllState();
  }

  toggleSelectAll() {
    this.columns.forEach(column => column.showColumn = this.selectAll);
    this.updateSelectAllState();
  }

  onOk(){
    if(this.columns.some(column => column.showColumn)){
      this._modalController.dismiss(this.columns);
    } else {
      this._responseNotificationService.showMessage('Please select at least one column', true);
    }
  }
  updateSelectAllState() {
    this.selectAll = this.columns.every(column => column.showColumn);    
  }
}
